import { render, staticRenderFns } from "./pageSdk.vue?vue&type=template&id=402693a0&scoped=true"
import script from "./pageSdk.vue?vue&type=script&lang=js"
export * from "./pageSdk.vue?vue&type=script&lang=js"
import style0 from "./pageSdk.vue?vue&type=style&index=0&id=402693a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402693a0",
  null
  
)

export default component.exports